import * as React from 'react';

import {
  TAdBannerPParams,
  TAdBannerPlaceParameters,
  TAdBannerSizes,
  TTgbNativedescGeneralDesign,
} from '../../../types/adBannerMicrofrontend';

/**
 * Значения размещения должны совпадать с легаси-баннером AdfoxBannerTGBBetweenOffers,
 * иначе адфокс отдаст другую кампанию.
 */
const PLACE = 'between_offers';
const P_PARAMS: TAdBannerPParams = { p1: 'cusvh', p2: 'fkhj' };
const SIZES: TAdBannerSizes = { width: '100%', height: 276 };
const TGB_NATIVEDESC_GENERAL_DESIGN: TTgbNativedescGeneralDesign = 'desktop-listingJK';

export function useTgbBetweenOffersParameters(position: number): TAdBannerPlaceParameters {
  return React.useMemo(
    (): TAdBannerPlaceParameters => ({
      carousel: null,
      deviceType: 'desktop',
      galleryPosition: null,
      isSp: false,
      pParams: P_PARAMS,
      place: PLACE,
      position,
      sizes: SIZES,
      tgbNativedescGeneralDesign: TGB_NATIVEDESC_GENERAL_DESIGN,
    }),
    [position],
  );
}
